import * as React from 'react';
import * as adaptiveStyles from './adaptive.css';
import * as styles from './flex.css';

import { mergeStyles } from '@cian/utils';

type adaptiveStyles = 'only_mobile' | 'only_tablet' | 'only_desktop';

export interface IFlexProps extends React.HTMLProps<HTMLDivElement> {
  justifyContent?: 'center' | 'flex-end' | 'initial' | 'space-between';
  alignItems?: 'center' | 'flex-end' | 'flex-start' | 'initial' | 'baseline';
  flexBasis?: 4 | 8 | 12 | 16 | 20 | 24 | 28 | 32 | 36 | 40 | 44 | 48 | 136;
  display?: 'flex' | 'block';
  direction?: 'row' | 'column';
  grow?: 'grow';
  wrap?: 'no-wrap';
  adaptive?: adaptiveStyles | Array<adaptiveStyles>;
}

const styleRuleControls = [
  'justifyContent',
  'alignItems',
  'flexBasis',
  'display',
  'direction',
  'grow',
  'wrap',
] as Keys<IFlexProps>;

const defaults: { [n: string]: undefined | IFlexProps['display'] } = { display: 'flex' };

function mapStyles(props: IFlexProps) {
  const base = mergeStyles(
    styles['base'],
    props.adaptive && ( Array.isArray(props.adaptive)
      ? props.adaptive.map((p) => adaptiveStyles[p])
      : adaptiveStyles[props.adaptive]
    ),
  );

  return styleRuleControls.reduce((acc, val) => {
    return mergeStyles(acc, props[val] ? styles[`${val}_${props[val] || defaults[val]}`] : undefined);
  }, base);
}

export function Flex({ children, ...rest }: IFlexProps) {
  return (
    <div
      {...mapStyles(rest)}
    >
      {children}
    </div>
  );
}
